"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.period.lastWeek': 'Settimana Scorsa',
    'reports.period.lastMonth': 'Mese Scorso',
    'reports.period.last3Months': 'Ultimi 3 Mesi',
    'reports.period.lastYear': 'Anno Scorso',
    'reports.period.allTime': 'Tutto il Tempo',
    'reports.period.custom': 'Intervallo Personalizzato',
};
